module.exports = __webpack_public_path__ + "static/media/pzzza_logo.423593ce.jpg";